<template>
    <div class="projects-container">
                         


                 <div class=" project-item">
                     <div class=" projects-image">
                        <img src="@/assets/saf.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                            This is my bigest project in android it is an application for booking trip this project is not finished yet 
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                               
                                <li>Firebase firestore as database</li>
                                <li>Java</li>
                            </ul>
                        </div>
                        <!-- <div class="project-links">
                            <div class="btn">
                                <span class="btn-bg">see code</span>
                            </div>
                            <div class="btn">
                                <span class="btn-light">go to see</span>
                            </div>
                            
                        </div> -->
                     </div>
                 </div>

                                  <div class=" project-item">
                     <div class=" projects-image" style="width: 100%;">
                        <img src="@/assets/recy.gif" alt="" srcset="">
                     </div>
                     <div class="project-description">
                         <div class="project-description-text">
                        <p>
                            
                    This is a simple block note for practice MVVM patern
                      </p>
                         </div>
                        <div class="description-text">
                            <p class="description-tech-title"> technologie used</p>
                            <ul class="description-tech">
                               
                                <li>Firebase firestore as database</li>
                                <li>Java</li>
                            </ul>
                        </div>
                        <div class="project-links">
                            <div class="btn">
                               
                                <a href="https://github.com/nila884/MVVMSqlliteBlockNote"> <span class="btn-bg">code</span></a>
                            </div>
                            
                            
                        </div>
                     </div>
                 </div>

                 <!-- <div style="margin-top: 2rem;">
                            <div class="btn">
                                <span class="btn-bg">more</span>
                            </div>
                 </div> -->
    </div>
</template>
<script>
export default {
    
}
</script>
